// Import Modules
import { Navigation } from './Modules/navigation.js';
import { initContrastToggle } from './Modules/contrast.js';
import { initStudyprogramAccordion } from './Modules/accordion.js';
import { initHeader } from './Modules/header.js';
import { initSearch } from './Modules/search.js';
import { initBreadcrumb } from './Modules/breadcrumb.js';
import { initSectionMenu } from './Modules/section-menu.js';
import { initStudyProgramList } from './Modules/Extensions/hskoblenz-study-programs.js';
import { audiencefilter } from './Modules/Extensions/audience-filter.js';
import { initSubmenuScroll } from './Modules/sliding-menu.js';
import { initCardTextCarousel } from "./Modules/card-text-carousel.js";
import { initEventsFilter } from "./Modules/events.js";

document.addEventListener('DOMContentLoaded', function () {
    new Navigation().init();
    initContrastToggle();
    initSubmenuScroll();
    initStudyprogramAccordion();
    initHeader();
    initSearch();
    initBreadcrumb();
    initSectionMenu();
    initStudyProgramList();
    audiencefilter();
    initCardTextCarousel();
    initEventsFilter();
});
